import { createMarkdownSection } from './MarkdownSection';

export const ExecutiveSummarySection = createMarkdownSection(
  'executive_summary.md',
  {
    title: 'Executive Summary',
    tooltip: 'View and manage the executive summary for this customer',
    editingStatus: 'Editing executive summary...',
    emptyTitle: 'No executive summary uploaded',
    emptyDescription:
      'Upload an executive_summary.md file to display content here',
    deleteModalTitle: 'Delete Executive Summary',
    deleteModalSubtitle:
      'Are you sure you want to delete the executive summary file? This action cannot be undone.',
  },
  { filePrefix: 'executive_summary_' }
);
